import React from 'react';
import DropdownComponent from 'components/Settings/WebsiteFeeds/DropdownComponent';

function EmailAddressesDropDown({ disabledCondition = false, senderAddresses, handleChange = () => {}, value }) {
  return (
    <div className='mt-2 website-feeds-popup-settings' data-testid='email-sender-dropdown'>
      <DropdownComponent
        mainItem={() => (
          <span className='hidden-lines hidden-one-line text-main-blue'>
            {value ? `${value.userName}@${value.crmDomainName}` : 'Select email address'}
          </span>
        )}
        disabled={disabledCondition}
      >
        <div className='scroll-container' style={{ maxHeight: '206px' }}>
          {senderAddresses.map((item) => (
            <button
              data-testid={`email-sender-option-${item.id}`}
              className='general-button specific-right-padding-16 specific-left-padding-25 specific-y-padding-10 text-left list-action-button border-bottom'
              key={item.id}
              value={item.id}
              onClick={() => {
                handleChange(item);
              }}
            >
              {item.emailAddress}
            </button>
          ))}
        </div>
      </DropdownComponent>
    </div>
  );
}

export default EmailAddressesDropDown;
